import CountdownTimer from './CountdownTimer'

export default CountdownTimer
// eslint-disable-next-line import/export
export * from './CountdownTimer'
